import axios from 'axios';

export const handlePaypalPayment = async ({ product, tier }) => {
    try {
        const response = await axios.post('/api/payments/paypal', {
            product,
            tier
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error processing PayPal payment:', error);
        throw error;
    }
};

export const handleBookPayment = async (book) => {
    try {
        const response = await axios.post('/api/payments/book', {
            book
        },
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error processing book payment:', error);
        throw error;
    }
};
